import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Checkbox from "@mui/material/Checkbox";
import PbTableRowProps from "./PbTableRowProps.type";
import PbTableCell from "../PbCell/PbTableCell";
import React from "react";
import styled from "@emotion/styled";
import { Paper } from "@mui/material";

const DetailContainer = styled(Paper)({
  display: "flex",
  flexDirection: "row",
  alignContent: "center",
  width: "100%",
});

function PbTableRow<T>(props: PbTableRowProps<T>): JSX.Element {

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(even)': {
      backgroundColor: props.alternate ? props.alternateColor : "#FFFFFF",
    },
  }));

  return (
    <>
      <StyledTableRow onClick={props.onClick}>
        {props.columns.map((col, index) => {
          return (
            <PbTableCell
              fieldName={col.id as string}
              index={index}
              isComponent={col.isComponent}
              value={
                props.rowData[col.id] ? props.rowData[col.id].toString() : "-"
              }
              component={
                col.isComponent ? (
                  <col.component row={props.rowData}></col.component>
                ) : null
              }
              key={
                (col.id ? col.id.toString : "row") +
                "-" +
                props.index +
                "-" +
                index
              }
            />
          );
        })}
      </StyledTableRow>
      {props.detailsComponent && props.isSelected ? (
        <>
        <TableRow></TableRow>
        <TableRow>
          <TableCell
            colSpan={props.columns.length}
            sx={{ paddingBottom: 0, paddingTop: 0, border: "0px", padding: "0px" }}
          >
            <DetailContainer elevation={2}>
              <props.detailsComponent row={props.rowData} />
            </DetailContainer>
          </TableCell>
        </TableRow>
        </>
      ) : null}
    </>
  );
}

export default PbTableRow;
